import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../pages/web/index.vue'
import Login from '../pages/backstage/login/login.vue'
Vue.use(VueRouter)
const routes = [
  //web页面
  {
    path: '/', 
    component: Home,
    meta:{title:'婧贤'},
    children:[
      {
        path:'/',
        redirect:'/index',
        meta:{title:'', requireAuth:false}
      },
      {
        path: '/index', 
        component: ()=>import('../pages/web/index.vue'),
        meta:{title:'', requireAuth:false},
      },
    ]
  },
  {
    path:'/magic',
    component: ()=>import('../pages/web/magic/magicindex.vue'),
    meta:{title:'', requireAuth:false},

  },
  {
    path: '/details',
    redirect:'/proser',
    component: ()=>import('../pages/web/details.vue'),
    meta:{title:'详情页',requireAuth:false},
    children:[
      {path:'/about',component:()=>import('../pages/web/components/about.vue'),meta:{title:'', requireAuth:false}},
      {path:'/cases',component:()=>import('../pages/web/components/cases.vue'),meta:{title:'', requireAuth:false}},
      {path:'/hr',component:()=>import('../pages/web/components/hr.vue'),meta:{title:'', requireAuth:false}},
      {path:'/proser',component:()=>import('../pages/web/components/proser.vue'),meta:{title:'', requireAuth:false}},
      {path:'/horecruitmentme',component:()=>import('../pages/web/components/recruitment.vue'),meta:{title:'', requireAuth:false}},
    ],
   
  },

  //后台管理
  {
    path: '/login', 
    component: Login,
    meta:{title:'婧贤',requireAuth:false },
    
    
  },
  {
    path: '/home', 
    component: ()=>import('../pages/backstage/index/index.vue'),
    meta:{title:'婧贤', requireAuth:false,},
    children:[
      {path:'/home',component:()=>import('../pages/backstage/page/home.vue'),meta:{title:'', requireAuth:false}},
      {path:'/case',component:()=>import('../pages/backstage/page/case.vue'),meta:{title:'', requireAuth:false}},
      {path:'/foundation',component:()=>import('../pages/backstage/page/foundation.vue'),meta:{title:'', requireAuth:false}},
      {path:'/hire',component:()=>import('../pages/backstage/page/hire.vue'),meta:{title:'', requireAuth:false}},
      {path:'/hrdigitize',component:()=>import('../pages/backstage/page/hrdigitize.vue'),meta:{title:'', requireAuth:false}},
      {path:'/proandser',component:()=>import('../pages/backstage/page/proandser.vue'),meta:{title:'', requireAuth:false}},
      {path:'/edit',component:()=>import('../pages/backstage/page/caseedit.vue'),meta:{title:'', requireAuth:false}},
    ],
  },
  {path:'*',component:Home},
]
//解决路由3.0及以上版本点击重复路由报错
const originalPush=VueRouter.prototype.push
VueRouter.prototype.push=function push(location){
  return originalPush.call(this,location).catch(err=>err)
}
const router = new VueRouter({
  mode:'history',
  routes,
  // scrollBehavior (to, from, savedPosition) {
  //   if (savedPosition) {
  //     return savedPosition
  //   } else {
  //     return { x: 0, y: 0 }
  //   }
  // }
})

router.beforeEach((to, from, next)=>{
  if(to.meta.title){
    // document.title=to.meta.title;
  };
  let cls=['/index','/details','/about','/cases','/hr','/proser','/horecruitmentme']
  cls.forEach((item)=>{
    if(to.path==item){
      sessionStorage.clear()
    }
  })
  if(to.meta.requireAuth){
    if(sessionStorage.getItem('user_token')){
      next()
    }else{
      next('/login');
    }
  }else{
    next()
    window.scrollTo(0,0);//解决跳转路由页面没有置顶的问题
  }
})  
export default router
